<script lang="ts">
    import Button from "../../materialize/components/Button.svelte";
    import InputField from "../../materialize/forms/InputField.svelte";
    import Label from "../../materialize/forms/Label.svelte";
    import PasswordField from "../../materialize/forms/PasswordField.svelte";
    import TextField from "../../materialize/forms/TextField.svelte";
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import { get_host } from "../../settings";
    import { auth_token } from "../../stores/stores";
    import { fetch_or_go_offline } from "../../utils/fetch_or_go_offline";
    import LoadingScreen from "./LoadingScreen.svelte";

    import {get_cookie} from "../../utils/cookie_manager";

    function logout() {
        $auth_token = "";
        //Navigate to another page
    }

    function login() {
        promise_login = fetch(get_host() + "/api/auth/obtain-token/", {
            method: "post",
            credentials: "same-origin",
            headers: {
                "X-CSRFToken": get_cookie("csrftoken"),
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ "username": username, password: password }),
        }).then((res) => {
            username="";
            password="";
            if (res.ok) {
                return res;
            } else {
                
                throw new Error("Impossibile fare login");
            }
        })
        .then((res)=>{ return res.json() }).then((res)=>{$auth_token = res.token});
    }

    let username;
    let password;
    let my_form: HTMLFormElement;
    

    let promise_login;
</script>

{#if $auth_token}
    <!-- Show logout -->
    <Row>
        <Button class_list={["right"]} on:click={logout}>LOGOUT</Button>
    </Row>
    
{:else}
    <!-- Show login -->
    <form bind:this={my_form} on:submit|preventDefault={login}>
        <Row><Column><h1>Accesso utente</h1></Column></Row>
        <Row><h5>Attenzione: zona per ora riservata a pochi stretti collaboratori</h5>
            <h5>Per ora non è possibile registrarsi</h5></Row>
        <Row>
            <Column small={12} medium={4}>
                <InputField prefix_icon="account_circle">
                    <TextField
                        bind:value={username}
                        required={true}
                        id="login_username"
                        label_text="Nome utente"
                        type="text"
                    />
                </InputField>
            </Column>
            <Column small={12} medium={4}>
                <InputField>
                    <PasswordField
                        bind:value={password}
                        required={true}
                        id="login_password"
                        label_text="Password"
                    />
                </InputField>
            </Column>

            <Column small={12} medium={4}>
                <Button class_list={[]}>ACCEDI</Button>
            </Column>

            {#await promise_login}
            {:catch}
                <Column>
                    <p class="center-align approu-error white-text">
                        Errore: hai inserito nome utente o password non
                        corretti. Riprova
                    </p>
                </Column>
            {/await}
        </Row>
    </form>
{/if}
